"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeOfU32 = void 0;
exports.SizeOfU32 = 4;
//# sourceMappingURL=constants.js.map